module.exports = __webpack_public_path__ + "media/images/favicon/android-chrome-192x192-c633c23276c13a0ed43e9b7bc42776a6.png";